module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"greetings":{"hi":"Hi {name}","welcome":"Welcome back again!"},"pro":{"title":"You are a Trader","byWhitelabel":"Exclusive benefit with"},"message":"A new day of profits..."},"es":{"greetings":{"hi":"Hola {name}","welcome":"¡Te damos la bienvenida de nuevo!"},"pro":{"title":"Eres un Trader","byWhitelabel":"Beneficio exclusivo por"},"message":"Un nuevo día para ganar..."}}')
  delete Component.options._Ctor
}
